import { SearchOptionsRequest } from "src/app/shared/models/SearchOptionsRequest.model";

export class TransactionsSearchOptionsDto extends SearchOptionsRequest {
    startDate: Date = null;
    endDate: Date = null;
    typeName: string = null;
    excludeFees: boolean = null;
}
